<section class="discharge-report-section">
  <h4 class="discharge-report-section-title">{{ title | translate }}</h4>
  <div class="discharge-report-section-body">
    <ng-content></ng-content>
  </div>
</section>
